import { useNavigate } from 'react-router-dom';

export const useFallbackNavigate = () => {
  let navigate;

  try {
    const reactNavigate = useNavigate();

    navigate = reactNavigate;
  } catch {
    navigate = (href) => (window.location.href = href);
  }

  return navigate;
};
